import { Label } from "@/store/models/Label";
import { Place } from "@/store/models/Place";
import stmicroelectronicsM5img from "@/assets/known-places/stmicroelectronics-m5.jpg";
const state = {
    labels:[],
    wkplaces:[]
}

const getters = {

}

const actions = {
    async init({commit, dispatch, rootState}){

        const labels = localStorage.getItem('labels')? JSON.parse(localStorage.getItem('labels')) : (rootState.metadata.models.views.map ? (rootState.metadata.models.views.map.default_labels || []) : []);
        if(labels.length){
            commit('updateLabels', labels.map( l => new Label(l.name, l.html, l.coordinates.latitude, l.coordinates.longitude)));
        }
        const places = [
            new Place(
                'STMicroelectronics M5',
                stmicroelectronicsM5img,//window.location.protocol + "//" + window.location.hostname + ':' + window.location.port + '/assets/known-places/stmicroelectronics-m5.jpg',
                [[37.435344, 15.055828], [37.442719, 15.055828], [37.442719, 15.066902], [37.435344, 15.066902]],
                [[37.439036, 15.060018], [37.440292, 15.060063], [37.440236, 15.062206], [37.439087, 15.062149]]
            )
        ];
        commit('updateWellKnownPlaces', places);
    },

    fetchLabels({commit, dispatch}){
        return new Promise(
            (resolve, reject)=>{
                try {
                    const labels = JSON.parse(localStorage.getItem('labels') || []);
                    commit('updateLabels', labels);
                    resolve(labels);
                } catch (error) {
                    reject(error)
                }
            }
        )
    },

    addLabel({commit, dispatch, rootState}, label){
        return new Promise(
            (resolve)=>{
                try {
                    const newLabels = rootState.map.labels.concat(label);
                    localStorage.setItem('labels', JSON.stringify(newLabels));
                    commit('updateLabels', newLabels);
                    resolve()
                } catch (error) {
                    reject(error);
                }
            }
        )
    },

    removeLabel({commit, dispatch}, label){
        return new Promise(
            (resolve, reject)=>{
                try {
                    const newLabels = state.labels.filter(l => l.name != label.name)
                    localStorage.setItem('labels', JSON.stringify(newLabels));
                    commit('updateLabels', newLabels);
                    resolve()
                } catch (error) {
                    reject(error);
                }
            }
        )
    },
}

const mutations = {
    updateLabels(state, labels){
        state.labels = labels;
    },
    updateWellKnownPlaces(state, wkplaces){
        state.wkplaces = wkplaces;
    }
}


export default{
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations,
    namespaced:true
}